import {FC} from 'react';

import DeviceTypeCode from '../../components/Dictionaries/DeviceTypes/device-type-code';

const DeviceTypeCodePage: FC = () => {
  return (
    <div>
      <DeviceTypeCode />
    </div>
  );
};

export default DeviceTypeCodePage;
